// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>10</span>&nbsp;&nbsp;With my whole heart have I sought you;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;O let me not go astray from your commandments.<br> </p> </div></div>";
// Exports
module.exports = code;